import React, { useEffect, useRef, useState } from "react";
import { Flex, Modal, Pagination, Tour } from "antd";
import { db } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";
import NotebookHeader from "./NotebookHeader";
import NotebookList from "./NotebookList";
import useStore from "../../store/useStore";
import useNotebookStore from "../../store/useNotebookStore";
import useModal from "../../store/useModal";

const CustomImageCard = () => {
  const { notebookList, setNotebookList } = useNotebookStore();

  const {
    isModalOpen,
    modalMessage,
    showModal,
    handleModalOk,
    handleModalCancel,
  } = useModal();

  const [currentPage, setCurrentPage] = useState(1);
  const [showTutorial, setShowTutorial] = useState(false);

  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();

  const { setRef } = useStore();
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    setRef("wordCreationTutorial", "ref1", ref1.current);
    setRef("wordCreationTutorial", "ref2", ref2.current);
    setRef("wordCreationTutorial", "ref3", ref3.current);
  }, [setRef]);

  useEffect(() => {
    const hasSeenWordCreationTutorial = localStorage.getItem(
      "hasSeenWordCreationTutorial"
    );
    if (!hasSeenWordCreationTutorial) {
      setShowTutorial(true);
    }
  }, []);

  const handleClose = () => {
    setShowTutorial(false);
    localStorage.setItem("hasSeenWordCreationTutorial", "true");
  };

  const tutorialSteps = [
    {
      title: (
        <>
          단어를 직접 만들고 싶으시다면
          <br />
          여기 페이지를 이용해주세요!
        </>
      ),
      placement: "bottom",
      target: () => ref1.current,
      nextButtonProps: { children: "다음" },
    },
    {
      title: <>수첩 추가하기를 눌러보세요!</>,
      placement: "left",
      target: () => ref2.current,
      prevButtonProps: { children: "이전" },
      nextButtonProps: { children: "다음" },
    },
    {
      title: (
        <>
          이 곳에 영어 단어와 뜻을 넣고
          <br />
          단어의 이미지를 직접 추가할 수 있어요.
          <br />
          미리 준비된 단어장으로 수업 진행이 가능합니다!
        </>
      ),
      placement: "right",
      target: () => ref3.current,
      prevButtonProps: { children: "이전" },
      nextButtonProps: { children: "완료" },
    },
  ];

  const tourStyle = {
    steps: tutorialSteps,
    open: showTutorial,
    onClose: handleClose,
  };

  const fetchNotebooks = async () => {
    const notebooks = await getNotebookData();
    setNotebookList(notebooks);
  };

  const getNotebookData = async () => {
    const querySnapshot = await getDocs(
      collection(db, "users", userId, "customCards")
    );

    return Promise.all(
      querySnapshot.docs.map(async (doc) => {
        const cardsSnapshot = await getDocs(
          collection(db, "users", userId, "customCards", doc.id, "cards")
        );
        const cards = cardsSnapshot.docs.map((cardDoc) => ({
          id: cardDoc.id,
          ...cardDoc.data(),
        }));

        return {
          id: doc.id,
          ...doc.data(),
          cards,
        };
      })
    );
  };

  useEffect(() => {
    fetchNotebooks();
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="custom-wrap box-border">
      <h4 ref={ref1}>새로운 단어 만들기</h4>
      <Flex
        vertical
        gap="large"
        className="border border-[#3D90EF] rounded-lg py-8 2xl:px-10 px-5"
      >
        <NotebookHeader refs={{ ref2 }} />

        <NotebookList
          ref3={ref3}
          showModal={showModal}
          fetchNotebooks={fetchNotebooks}
        />
      </Flex>

      <Pagination
        className="note-pagination flex justify-center"
        current={currentPage}
        total={notebookList.length}
        pageSize={10}
        onChange={handlePageChange}
      />

      <Modal
        title="알림"
        open={isModalOpen}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        closeIcon={false}
        okText="네"
        cancelText="아니오"
        className="text-center"
      >
        <p className="text-center py-5 px-5">{modalMessage}</p>
      </Modal>

      {/* <UploadModal
        setNotebookList={setNotebookList}
        fileUploadModal={fileUploadModal}
        setFileUploadModal={setFileUploadModal}
      /> */}

      <Tour
        {...tourStyle}
        steps={tutorialSteps}
        indicatorsRender={(current, total) => (
          <span>
            {current + 1} / {total}
          </span>
        )}
        gap={{ radius: 8 }}
      />
    </div>
  );
};

export default CustomImageCard;
